import {deleteJson, getJson, patchJson, postJson} from '@/util/ajaxUtils';

export function addAppTag(appTag) {
    return postJson('/apptags', {data: appTag});
}

export function updateAppTag(appTagId, appTag) {
    return patchJson(`/apptags/${appTagId}`, {data: appTag});
}

export function deleteAppTag(appTagId) {
    return deleteJson(`/apptags/${appTagId}`);
}

export function getAllAppTags(appId, tagType, tagName) {
    return getJson('/apptags', {params: {appId, tagType, tagName}});
}

export function getAppTags(appId, adType) {
    return getJson(`/apptags/list`, {params: {appId, adType}});
}

export function getAppMembers(appId) {
    return getJson(`/app-users/members/${appId}`);
}

export function getAppManager(appId) {
    return getJson(`/app-users/managers/${appId}`);
}
